import { forwardRef, useRef, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import {
  type MenuItem,
  type LiliComboboxWithInputValueConstraint,
  SelectMenuItem,
} from './SelectMenuItem';

interface SelectMenuListProps<T extends LiliComboboxWithInputValueConstraint> {
  id: string;
  items: MenuItem<T>[];
  selectedValue: T;
  searchWord: string;
  onItemClick: (value: T) => void;
}

export const SelectMenuList = forwardRef<HTMLDivElement, SelectMenuListProps<any>>(
  ({ id, items, selectedValue, searchWord, onItemClick }, _ref) => {
    const elListContainer = useRef<HTMLDivElement>(null);
    const [isScrolled, setIsScrolled] = useState(false);

    const handleScroll = () => {
      if (elListContainer.current) {
        const { scrollTop } = elListContainer.current;
        setIsScrolled(scrollTop > 0);
      }
    };

    const containerClass = twMerge(
      'w-full flex flex-col mt-[8px] max-h-[200px] overflow-scroll',
      isScrolled && 'border-t border-outline-primary-bw-03 -translate-y-[1px]'
    );

    return (
      <div translate='no' ref={elListContainer} className={containerClass} onScroll={handleScroll}>
        {items.map((item) => (
          <SelectMenuItem
            id={id}
            key={item.value || item.itemDescription || item.title}
            item={item}
            searchWord={searchWord}
            isSelected={item.value === selectedValue}
            onClick={onItemClick}
          />
        ))}
      </div>
    );
  }
);
